import { render, staticRenderFns } from "./_Wallet.vue?vue&type=template&id=901b08e8&scoped=true"
import script from "./_Wallet.vue?vue&type=script&lang=js"
export * from "./_Wallet.vue?vue&type=script&lang=js"
import style0 from "./_Wallet.vue?vue&type=style&index=0&id=901b08e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901b08e8",
  null
  
)

export default component.exports